module.exports = __webpack_public_path__ + "img/gh_pic04-7bbdab.png";